import React, { useLayoutEffect } from "react";
import "../Css/Contact.css";
import { Button, Form, Input, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import Footer from "../Component/FooterComponent/Footer";
import axios from "axios";
import { API_BASE_URL, LEAD_API_BASE_URL } from "../services/apiConfig";

const Contact = () => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const submitForm = async (values) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}contact`,
        {
          fullName: values.name,
          email: values.email,
          phone: values.contact,
          message: values.message,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        messageApi.success(
          "Your message has been sent successfully. Our team will contact you soon."
        );

        form.resetFields();
      } else {
        messageApi.error(
          response.data?.message ||
            "Unable to send your message. Please try again."
        );
      }
    } catch (error) {
      console.error(
        "Contact form error:",
        error.response?.data || error.message
      );

      messageApi.error(
        error.response?.data?.message ||
          "Unable to send your message right now. Please try again later."
      );
    }
  };

  return (
    <>
      {contextHolder}

      <section className="contact-page-banner-section">
        <div className="contact-page-banner-con">
          <h2>Contact us</h2>
        </div>
      </section>

      <section className="contact-page-section-2">
        <div className="contact-page-section-2-form-con">
          <div className="contact-page-section-2-form">
            <div className="contact-page-section-2-heading">
              <h3>Write us a message.</h3>
            </div>

            <div className="contact-page-section-2-main-form">
              <Form form={form} onFinish={submitForm}>
                <Form.Item
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your name!",
                    },
                  ]}
                >
                  <Input placeholder="Full Name" />
                </Form.Item>

                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email!",
                    },
                    {
                      type: "email",
                      message: "Please enter a valid email!",
                    },
                  ]}
                >
                  <Input type="email" placeholder="Email" />
                </Form.Item>

                <Form.Item
                  name="contact"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Contact!",
                    },
                    {
                      pattern: /^\d{10}$/,
                      message: "Please enter a valid 10-digit contact number!",
                    },
                  ]}
                >
                  <Input
                    type="tel"
                    inputMode="numeric"
                    maxLength={10}
                    placeholder="Phone Number"
                  />
                </Form.Item>

                <Form.Item
                  name="message"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Message!",
                    },
                  ]}
                >
                  <TextArea placeholder="Message" rows={6} />
                </Form.Item>

                <Form.Item>
                  <div className="contact-page-sumbit-btn">
                    <Button htmlType="submit">
                      Send
                    </Button>
                  </div>
                </Form.Item>
              </Form>

              <p>
                This site is protected by reCAPTCHA and the Google Privacy
                Policy and Terms of Service apply.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;
